module.exports = __webpack_public_path__ + "img/p21.41f03b6d.jpg";